Ext.define('SA.view.DividerComboButton', {
    alias: 'widget.divider-combo-button',
    extend: 'SA.view.SimpleContainer',

    baseCls: 'sa-divider-combo-button',

    initComponent() {
        this.items = [
            {
                xtype: 'component',
                cls: 'sa-divider-combo-button-divider'
            }, {
                xtype: 'combo-button',
                cls: 'sa-divider-combo-button-button',
                items: this.items,
                menuCls: 'sa-menu-compact',
                selectHandler: this.selectHandler,
                value: this.value
            }, {
                xtype: 'component',
                cls: 'sa-divider-combo-button-divider'
            }
        ];

        this.callParent();

        this.combo = this.down('combo-button');
    },

    initEvents() {
        this.callParent();

        this.combo.on('change', (_, value) => this.fireEvent('change', value));
    },

    getValue() {
        return this.combo.getValue();
    },

    setValue(value) {
        this.combo.setValue(value);
    },

    setValueUnevented(value) {
        this.combo.setValueUnevented(value);
    }
});